import React, { useState, useEffect } from "react";
import { db } from "../../backend/firebaseConfig";
import { collection, doc, onSnapshot, deleteDoc, updateDoc, addDoc } from "firebase/firestore";

// Fetch notifications
export const fetchNotifications = (currentUser, callback) => {
  if (currentUser) {
    const notificationsRef = collection(db, "notifications", currentUser.uid, "userNotifications");
    const unsubscribe = onSnapshot(notificationsRef, (snapshot) => {
      const fetchedNotifications = [];
      snapshot.forEach((doc) => {
        fetchedNotifications.push({
          id: doc.id,
          ...doc.data()
        });
      });
      callback(fetchedNotifications);
    });
    return unsubscribe;
  }
};

// Mark notification as read
export const markNotificationAsRead = async (currentUser, notificationId) => {
  if (currentUser) {
    const notificationRef = doc(db, "notifications", currentUser.uid, "userNotifications", notificationId);
    try {
      await updateDoc(notificationRef, { read: true });
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  }
};

// Delete notification
export const deleteNotification = async (currentUser, notificationId, callback) => {
  if (currentUser) {
    const notificationRef = doc(db, "notifications", currentUser.uid, "userNotifications", notificationId);
    try {
      await deleteDoc(notificationRef);
      if (callback) {
        callback((prev) => prev.filter((notif) => notif.id !== notificationId));
      }
    } catch (error) {
      console.error("Error deleting notification:", error);
    }
  }
};

// Add notification
export const addNotification = async (userId, message) => {
  const notificationsRef = collection(db, "notifications", userId, "userNotifications");
  const newNotification = {
    message,
    timestamp: new Date().toISOString(),
    read: false
  };
  try {
    await addDoc(notificationsRef, newNotification);
  } catch (error) {
    console.error("Error adding notification:", error);
  }
};